import { useEffect, useRef, useState } from 'react';

import { useViewportResize } from './useResize';

const useResizeDetect = () => {
  const [isResize, setResize] = useState(false);
  const clearRef = useRef<Function>();

  useViewportResize(() => setResize(true));

  useEffect(() => {
    if (!isResize) return;

    clearRef.current?.();

    const id = setTimeout(() => {
      setResize(false);
    }, 1500);

    clearRef.current = () => clearTimeout(id);
    return () => {
      clearRef.current?.();
    };
  }, [isResize]);

  return isResize;
};

export const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState(false);
  const isResize = useResizeDetect();
  const ref = useRef(false);
  ref.current = isResize;

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      setTimeout(() => {
        if (ref.current) return;

        const scrollY = window.pageYOffset;
        const direction = scrollY > lastScrollY;
        if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
          setScrollDirection(direction);
        }
        lastScrollY = scrollY > 0 ? scrollY : 0;
      }, 300);
    };

    window.addEventListener('scroll', updateScrollDirection);
    return () => {
      window.removeEventListener('scroll', updateScrollDirection);
    };
  }, [scrollDirection]);

  return scrollDirection;
};
